var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-end q-gutter-sm"},[_c('ActionShowButton',{attrs:{"url":_vm.routes.show(_vm.invoice.id)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }